module.exports = __webpack_public_path__ + "static/media/Moj-4.19f244cd.PNG";